import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { RangeSlider } from './utils';
import ReplayContext from './ReplayContext';
import {
    STREAM_FETCHED, STREAM_FETCHING, EVENT_CLEAR_STREAM
} from './GPSPlayer';

const RANGE = "range";
export default class TimeRange extends React.Component {
    static contextType = ReplayContext;

    constructor() {
        super();

        this.gpsPlayer = null;
        this.state = {
            step: 30,
            domain: [0, 1],
            values: [0, 0],
            reversed: false,
            tickValues: []
        };
    }

    componentDidMount() {
        if (this.context.mapMarker) this.context.mapMarker.showMarkers();
        this.gpsPlayer = this.context.gpsPlayer;

        this.gpsPlayer.addListener(STREAM_FETCHING, RANGE, () => {
            this.removePopupColor();
        }).addListener(STREAM_FETCHED, RANGE, ({ start, end }) => {
            if (!(start && end)) return;
            this.highlightPopup();
            this.gpsPlayer.play();
        }).addListener(EVENT_CLEAR_STREAM, RANGE, () => {
            this.removePopupColor();
        });

        this.setScale();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.range >= 1 && prevProps.range === this.props.range) return;
        this.setScale();
    }

    setScale = () => {
        let minRange = this.props.domain[0], maxRange = this.props.domain[1];

        if (!(this.state.domain && this.state.values &&
            minRange === this.state.domain[0] && maxRange === this.state.domain[1])) {

            const minValue = (this.props.values[0] !== null) ? this.props.values[0] : minRange;
            const maxValue = (this.props.values[1] !== null) ? this.props.values[1] : maxRange;
            const tickValues = this.getTickInterval(minRange, maxRange);
            const hours = (maxRange - minRange) / 60;

            this.setState({
                domain: [minRange, maxRange], values: [minValue, maxValue],
                tickValues, step: (hours > 24) ? 60 : 30
            });

            this.props.onUpdate({ min: minValue, max: maxValue });
        }
    }

    getTickInterval = (minRange, maxRange) => {
        let tickInterval = 0;
        const range = (maxRange - minRange);
        const rangeHours = (range / 60);

        if (rangeHours >= 0 && rangeHours <= 8) tickInterval = 1;
        else if (rangeHours >= 9 && rangeHours <= 12) tickInterval = 2;
        else if (rangeHours >= 13 && rangeHours <= 18) tickInterval = 3;
        else if (rangeHours >= 19 && rangeHours <= 24) tickInterval = 4;
        else if (rangeHours > 24 && rangeHours <= 7 * 24) tickInterval = 24;
        else tickInterval = 48;
        tickInterval *= 60;

        const tickValues = [];
        const tickCount = Math.ceil(range / tickInterval);
        for (let i = 0; i < tickCount; i++) {
            tickValues.push((i * tickInterval) + minRange);
        }
        tickValues.push(maxRange);
        return tickValues;
    }

    highlightPopup = () => {
        const gpsPoints = this.gpsPlayer.getGPSPoints();
        for (const egId in gpsPoints) {
            const infoElement = document.getElementById(`infowindow_${egId}`);
            if (!infoElement) continue;

            const egItem = this.gpsPlayer.getEgItem(egId);
            if (!egItem) continue;
            infoElement.className = `info-active map-popup_text`;
            infoElement.style.background = egItem.color;
        }
    }

    removePopupColor = () => {
        const infoElements = document.querySelectorAll('.info-active');
        for (const element of infoElements) {
            if (!element) continue;
            element.classList.remove("info-active");
            element.style.background = "none";
        }
    }

    onUpdate = update => {
        this.setState({ update });
        this.props.onUpdate({ min: update[0], max: update[1] });
    }

    formatTicks = value => {
        if (!this.props.dateRange.start) return;
        const tickDate = this.props.dateRange.start.clone().add(value, "minutes");
        return tickDate.format(this.props.domain[1] > (24 * 60) ? "DD MMM hh:mm a" : "hh:mm a");
    }

    handleGo = () => {
        this.props.fetchStream();
    }

    componentWillUnmount() {
        this.removePopupColor();
        this.gpsPlayer.removeListenerByName(RANGE);
    }

    render() {
        const { state: { step, domain, values, reversed, tickValues } } = this;

        return <Row className="mx-0 timerange-row">
            <Col md={11}>
                <RangeSlider
                    step={step}
                    domain={domain}
                    reversed={reversed}
                    tickValues={tickValues}
                    values={values}
                    onUpdate={this.onUpdate}
                    onChange={values => this.setState({ values })}
                    formatTicks={this.formatTicks} />
            </Col>
            <Col md={1} className="px-0">
                <Button variant="success" className="float-right" size="sm" title="GO"
                    onClick={this.handleGo}>GO</Button>
            </Col>
        </Row>;
    }
}
